<ion-tabs #tabs>
  <ion-tab-bar slot="bottom" color="light">
    <ion-tab-button tab="stops" (click)="openTab('stops', $event)">
      <ion-icon src="/assets/icon/expreso.svg"></ion-icon>
      <ion-label>Transporte</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="profile" (click)="openTab('profile', $event)">
      <ion-icon src="/assets/icon/profile-icon.svg"></ion-icon>
      <ion-label>Perfil</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
